import ErrorHandler from '@/ErrorHandler';
import GlobalEventBus from '@/GlobalEventBus';
import GlobalEvents from '@/GlobalEvents';
import API from '@/org-app/api';
import {
  createApiAction,
  createDeleteAction,
  createGetAllAction,
  createGetOneAction,
  createPostAction,
  createPutAction,
} from '@/utils/ActionsUtils';
import i18n from '@/vueI18n';

import * as types from './mutation-types';

const actions = {
  getOwnerYieldManagerSsps: createGetAllAction(
    API.instance.getOwnerYieldManagerSsps,
    types.UPDATE_OWNER_YIELD_MANAGER_SSPS_LIST,
    'messages.failedToGetOwnerYieldManagerSsps',
    false,
  ),
  getOwnerYieldManagerSsp: createGetOneAction(
    API.instance.getOwnerYieldManagerSsp,
    types.UPDATE_OWNER_YIELD_MANAGER_SSP,
    'messages.failedToGetOwnerYieldManagerSsps',
    true,
  ),
  createOwnerYieldManagerSsp: createPostAction(
    API.instance.postOwnerYieldManagerSsp,
    types.SAVE_OWNER_YIELD_MANAGER_SSP,
    'messages.failedToSaveOwnerYieldManagerSsps',
  ),
  updateOwnerYieldManagerSsp: createPutAction(
    API.instance.putOwnerYieldManagerSsp,
    types.SAVE_OWNER_YIELD_MANAGER_SSP,
    'messages.failedToSaveOwnerYieldManagerSsps',
  ),
  deleteOwnerYieldManagerSsp: createDeleteAction(
    API.instance.deleteOwnerYieldManagerSsp,
    types.DELETE_OWNER_YIELD_MANAGER_SSP,
    'messages.failedToDeleteOwnerYieldManagerSsps',
  ),
  createSspWithDomain: createApiAction(
    API.instance.createSspWithDomain,
    types.SAVE_OWNER_YIELD_MANAGER_SSP,
    'messages.failedToSaveOwnerYieldManagerSsps',
  ),
  getYieldManagerBidStats: createApiAction(
    API.instance.getYieldManagerBidStats,
    null,
    'messages.failedToGetBidStats',
    false,
  ),

  async uploadOwnerYieldManagerSspLogo({ commit }, { file, id, showLoader = true, cancelTokenSource }) {
    GlobalEventBus.$emit(GlobalEvents.loading);
    try {
      const data = await API.instance.uploadOwnerYieldManagerSspLogo(file, id, cancelTokenSource);
      return data;
    } catch (err) {
      const msg = i18n.global.t('messages.failedToUploadLogo');
      ErrorHandler.showError(msg, err);
      throw err;
    } finally {
      if (showLoader) {
        GlobalEventBus.$emit(GlobalEvents.loaded);
      }
    }
  },
};

export default actions;
